import { useEffect } from 'react';
import { hasMessageChanged } from '../utils/messageComparison';

/**
 * Synchronizes the selected message in the drawer with the messages array.
 * Updates selectedMessage when underlying data changes and closes drawer if message is deleted.
 * 
 * @param {Array} messages - Array of all messages
 * @param {Object} selectedMessage - Currently selected message
 * @param {Function} setSelectedMessage - Setter for selected message
 * @param {boolean} drawerVisible - Whether the drawer is visible
 * @param {Function} setDrawerVisible - Setter for drawer visibility
 */
const useSelectedMessageSync = (messages, selectedMessage, setSelectedMessage, drawerVisible, setDrawerVisible) => {
    useEffect(() => {
        if (selectedMessage?.id) {
            const updated = messages.find(m => m.id === selectedMessage.id);

            if (updated && hasMessageChanged(selectedMessage, updated)) {
                setSelectedMessage(updated);
            }

            // If the message was deleted, close the drawer
            if (!updated && drawerVisible) {
                setDrawerVisible(false);
                setSelectedMessage(null);
            }
        }
    }, [messages, selectedMessage?.id, drawerVisible, selectedMessage, setSelectedMessage, setDrawerVisible]);
};

export default useSelectedMessageSync;
